module.exports = __webpack_public_path__ + "img/top-banner-win.cdfd2842.png";